import React from 'react';
import { Empty } from 'antd';
import AdherencePage from '../../pages/AdherencePage';
import WindowNote from './WindowNote';

/**
 * Schedule adherence for the team, rendered by the page that already computes it.
 *
 * Scoped by TEAM, not campaign. Adherence is recorded against a team and nothing
 * in the data joins a team to a campaign, so the banner says so -- this tab
 * sits under a heading naming a campaign and the numbers are not about it.
 */
export default function AdherenceTab({ teamId, team, from, to }) {
  if (!teamId) {
    return <Empty description="Select a team" image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ marginTop: 40 }} />;
  }
  return (
    <>
      <WindowNote from={from} to={to} />
      <AdherencePage embedded teamId={teamId} from={from} to={to} />
    </>
  );
}
